import {Fragment, useState} from 'react';

import UserDropdown from './UserDropdown';
import NavbarBookmarks from "./NavbarBookmarks";
import {BiLogOut} from "react-icons/bi";
import {LogOutModal} from "./logOutModal/logOutModal";

// ** Custom Components
//import NavbarBookmarks from './NavbarBookmarks'

// ** Third Party Components
//import {Moon, Sun} from 'react-feather'

const ThemeNavbar = props => {
    // ** Props
    const {skin, setSkin, setMenuVisibility} = props
    const [modal, setModal] = useState(false)


    // ** Function to toggle Theme (Light/Dark)
    /*const ThemeToggler = () => {
        if (skin === 'dark') {
            return <Sun className='ficon' onClick={() => setSkin('light')}/>
        } else {
            return <Moon className='ficon' onClick={() => setSkin('dark')}/>
        }
    }*/
    const toggleModal = () => {
        setModal(!modal)
    }
    return (
        <Fragment>
            <div className='bookmark-wrapper d-flex align-items-center'>
                <NavbarBookmarks setMenuVisibility={setMenuVisibility}/>
                {/*<span className="text-primary font-weight-bold font-large-1">*/}
                {/*    {DETAILS.name}*/}
                {/*</span>*/}
            </div>
            <ul className='nav navbar-nav align-items-center ml-auto'>
                <BiLogOut size={22} onClick={() => toggleModal()} className="cursor-pointer"/>
                <UserDropdown/>
            </ul>
            <LogOutModal
                isOpen={modal}
                toggleModal={toggleModal}
            />
        </Fragment>
    )
}

export default ThemeNavbar
